export const PRIVACY_KEY = 'g1sport:privacy:v2';
export const PRIVACY_EVENT = 'g1sport:privacy';
export type PrivacyChoice = {audience:boolean; advertising:boolean; at:number};
export function privacyBlocked(): boolean {
  return !!(navigator as any).globalPrivacyControl || navigator.doNotTrack === '1' || navigator.userAgent.includes('G1SportNative');
}
export function readPrivacy(): PrivacyChoice | null {
  try {
    const value = (window as any).__g1sportPrivacy || JSON.parse(localStorage.getItem(PRIVACY_KEY) || 'null');
    return value && typeof value.at === 'number' && value.at <= Date.now() && Date.now()-value.at < 15552000000
      && typeof value.audience === 'boolean' && typeof value.advertising === 'boolean' ? value : null;
  } catch { return null; }
}
export const audienceAllowed = () => !privacyBlocked() && readPrivacy()?.audience === true;
export const advertisingAllowed = () => !privacyBlocked() && readPrivacy()?.advertising === true;
export function savePrivacy(audience:boolean, advertising:boolean): void {
  const value = {audience:audience && !privacyBlocked(), advertising:advertising && !privacyBlocked(), at:Date.now()};
  (window as any).__g1sportPrivacy=value;
  try { localStorage.setItem(PRIVACY_KEY,JSON.stringify(value)); localStorage.removeItem('g1_ad_consent'); localStorage.removeItem('devantiq:audience-consent:v1'); } catch {}
  window.dispatchEvent(new Event(PRIVACY_EVENT));
}
